import { HTTP as http } from '../http-common'

export default {
    async getWorkflow() {
      return await http.get(`/api/workflow/get-all`)
    },

    // async getWorkflowById(id){
    //     return await http.get(`/api/workflow/get-by-id/${id}`)
    // },

    async deleteWorkflow(code){
        return await http.delete(`api/workflow/delete-step/${code}`)
    },

    async addWorkflow(formdata){
        return await http.post(`/api/workflow/add-step`,formdata)
    },

    async editWorkflow(code,data){
        return await http.put(`/api/workflow/update-step/${code}`,data)
    }
  };

